import React, { useEffect, useState } from "react";
import { FaStar as Star } from "react-icons/fa";

const colors = {
  orange: "#facc15",
  grey: "#BDBEBF",
};

const RatingStars = ({ rating, onRatingChange, size = "small", interactive = false }) => {
  const [currentValue, setCurrentValue] = useState(rating);
  const [hoverValue, setHoverValue] = useState(0);
  const stars = Array(5).fill(0);
  
  useEffect(() => {
    setCurrentValue(rating);
  }, [rating]);

  const handleStarClick = (index) => {
    if (interactive && onRatingChange) {
      const newRating = index + 1;
      setCurrentValue(newRating);
      onRatingChange(newRating);
    }
  };

  const handleStarHover = (index) => {
    if (interactive) {
      setHoverValue(index + 1);
    }
  };

  const handleStarLeave = () => {
    if (interactive) {
      setHoverValue(0);
    }
  };

  const getStarColor = (index) => {
    const displayValue = hoverValue || currentValue;
    return displayValue > index ? colors.orange : colors.grey;
  };

  const getStarSize = () => {
    switch (size) {
      case "35px":
        return "text-[35px]";
      case "xlarge":
        return "text-3xl";
      case "large":
        return "text-xl";
      case "medium":
        return "text-base";
      case "small":
      default:
        return "text-sm";
    }
  };

  return (
    <div className="flex items-center w-fit">
      {stars.map((e, index) => {
        const starSize = getStarSize();
        const isCustomSize = typeof starSize === 'object';
        
        return (
          <Star
            className={isCustomSize ? "" : starSize}
            key={index}
            color={getStarColor(index)}
            style={{ 
              marginRight: 6,
              cursor: interactive ? "pointer" : "default",
              ...(isCustomSize ? starSize : {})
            }}
            onClick={() => handleStarClick(index)}
            onMouseEnter={() => handleStarHover(index)}
            onMouseLeave={handleStarLeave}
          />
        );
      })}
    </div>
  );
};

export default RatingStars;